export const iconFontAwesomeAutomotiveGaugeSimpleHigh = (
	<i className="fa-solid fa-gauge-simple-high"></i>
);
